<template>
  <v-app id="logined" class="pa-5 background mx-3 rounded-xl">
    <v-fade-transition mode="out-in"> </v-fade-transition>

    <v-fade-transition mode="out-in"> </v-fade-transition>
    <v-container grid-list-xs class="pa-0 background">
      <v-slide-y-transition mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-slide-y-transition>
    </v-container>
  </v-app>
</template>

<script>
import MToolbar from '@/components/Toolbar'

export default {
  components: {
    MToolbar,
  },
  computed: {},
  methods: {},
}
</script>
<style lang="css">
@media only screen and (min-width: 960px) {
  .container {
    max-width: 1280px;
  }
}
</style>
